"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyField = void 0;
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const text_field_1 = require("../text-field/text-field");
function ReadonlyField({ dataMapper = lodash_1.identity, ...props }) {
    return react_1.default.createElement(text_field_1.TextField, { ...props, value: dataMapper(props.value), disabled: true });
}
exports.ReadonlyField = ReadonlyField;
//# sourceMappingURL=readonly-field.js.map